@if (attachment.id === '') {
  <div>
    <a #blob class="hide"></a>
    <a [routerLink]="[]" (click)="downloadAttachment(attachment)" class="cursor-pointer d-flex">
      <fa-icon icon="paperclip"></fa-icon>
      <span>&nbsp;{{ attachment.filename }}</span>
    </a>
  </div>
}
